import axios from "axios";
import Request from "axios-request-handler";
import { initDeviceId, initProfiling } from "../device";
import eventAnalytics from '../../analytikaV2';

export async function loginWithPhone(payload, clientId) {
  const endpoint = getEndpoint(`/login/customer/phone`);

  return login(endpoint, clientId, payload, true, true);
}
export async function loginWithOneClick(payload, clientId) {
  const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/login/one-click`;
  return login(endpoint, clientId, payload);
}

export function verifyApproveRequestStatus(id) {
  const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/login/approve-request/${id}/verify`;
  return new Request(endpoint);
}

export async function proofApproveRequest(id, clientId) {
  let profiling = await initProfiling().catch((ex) => {
    console.log(ex);
  });
  const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/login/approve-request/${id}/proof`;
  return axios
    .post(
      endpoint,
      { profiling },
      {
        headers: {
          "x-idp-client-id": clientId,
        },
      }
    )
    .then((res) => res?.data);
}

export async function loginWithApple(payload, clientId) {
  const endpoint = getEndpoint(`/login/apple`);

  return login(endpoint, clientId, payload, true, true);
}

export async function loginWithGoogle(payload, clientId) {
  const endpoint = getEndpoint(`/login/google`);

  return login(endpoint, clientId, payload, true, true);
}

export async function loginWithEmail(payload, clientId) {
  const endpoint = getEndpoint(`/login/customer/email`);

  return login(endpoint, clientId, payload, true, true);
}

export async function loginWithMerchantEmail(payload, clientId) {
  const endpoint = getEndpoint(`/login/merchant/email`);

  return login(endpoint, clientId, payload, true, true);
}

export async function loginWithInstantCredentials(payload, clientId) {
  const endpoint = getEndpoint(`/login/merchant_operator`);

  return login(endpoint, clientId, payload, true, true);
}

async function login(
  endpoint,
  clientId,
  payload,
  withDeviceIdHeader = true,
  withOnboarderHeaders = false
) {
  payload.device_id = await initDeviceId();

  let headers = { "x-idp-client-id": clientId};
  if (withDeviceIdHeader) {
    headers["x-careem-device-id"] = payload.device_id;
  }
  if (withOnboarderHeaders) {
    headers["agent"] = "WEB";
    headers["version"] = "1";
  }

  const sessionUuid = eventAnalytics.getSessionUuid();
  if (sessionUuid) {
    headers["X-Careem-Session-Id"] = sessionUuid;
  }

  return axios
    .post(endpoint, payload, {
      headers,
    })
    .then((res) => res?.data);
}

function getEndpoint(pathOnboarder) {
  return `${process.env.REACT_APP_IDENTITY_SERVICES_ONBOARDER_HOST}`.concat(
    pathOnboarder
  );
}
